"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
var selectors_1 = require("../customer/selectors");
exports.setPreference = function (key, value) { return function (dispatch, getState) {
    var profileId = selectors_1.selectedProfileId(getState()) || 'default'; // Use 'default' for non-logged-in users
    return dispatch(toolkit_1.createAction(constants_1.SET_PREFERENCE)({
        profileId: profileId,
        key: key,
        value: value,
    }));
}; };
exports.setSelectedCategoryId = function (categoryId) { return function (dispatch, getState) {
    var profileId = selectors_1.selectedProfileId(getState()) || 'default'; // Use 'default' for non-logged-in users
    return dispatch(toolkit_1.createAction(constants_1.SET_SELECTED_CATEGORY_ID)({
        profileId: profileId,
        categoryId: categoryId,
    }));
}; };
exports.clearPreferences = function () { return function (dispatch, getState) {
    var profileId = selectors_1.selectedProfileId(getState()) || 'default'; // Use 'default' for non-logged-in users
    return dispatch(toolkit_1.createAction(constants_1.CLEAR_PREFERENCES)({
        profileId: profileId,
    }));
}; };
//# sourceMappingURL=actions.js.map